module.exports = __webpack_public_path__ + "img/sld_mfm_aux_withoutStick.203e1800.svg";